import { render } from "./settingtab.vue?vue&type=template&id=40f655bd"
import script from "./settingtab.vue?vue&type=script&lang=js"
export * from "./settingtab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__